import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Welcome from './pages/Welcome'
import Home from './pages/Home'
import GamePictureWord from './pages/GamePictureWord'
import GameAudioWord from './pages/GameAudioWord'
import GameMatching from './pages/GameMatching'
import GameQuiz from './pages/GameQuiz'
import LearnMode from './pages/LearnMode'
import Progress from './pages/Progress'
import Leaderboard from './pages/Leaderboard'
import Achievements from './pages/Achievements'
import DebugData from './pages/DebugData'
import { GameProvider } from './context/GameContext'
import { GameSessionProvider } from './context/GameSessionContext'

function App() {
  return (
    <GameProvider>
      <GameSessionProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/welcome" element={<Welcome />} />
            <Route path="/game/picture-word" element={<GamePictureWord />} />
            <Route path="/game/audio-word" element={<GameAudioWord />} />
            <Route path="/game/matching" element={<GameMatching />} />
            <Route path="/game/quiz" element={<GameQuiz />} />
            <Route path="/learn" element={<LearnMode />} />
            <Route path="/progress" element={<Progress />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/achievements" element={<Achievements />} />
            <Route path="/debug-data" element={<DebugData />} />
          </Routes>
        </BrowserRouter>
      </GameSessionProvider>
    </GameProvider>
  )
}

export default App
